import { render, staticRenderFns } from "./ShopSummaryPage.vue?vue&type=template&id=6634125f&scoped=true"
import script from "./ShopSummaryPage.vue?vue&type=script&lang=js"
export * from "./ShopSummaryPage.vue?vue&type=script&lang=js"
import style0 from "./ShopSummaryPage.vue?vue&type=style&index=0&id=6634125f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6634125f",
  null
  
)

export default component.exports